import React from 'react';

import { ButtonProps } from '@/components/shadcn/ui/button';
import { ConnectedDogeWallet } from '@/networks/btc-like/doge';

const HeaderWalletDrawerDogeWalletConnect: React.FC<ButtonProps> = (props) => {
  return <ConnectedDogeWallet {...props} />;
};

export default HeaderWalletDrawerDogeWalletConnect;
